<script lang="ts" setup>
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

const props = defineProps({
  isAttendance: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
});

const emits = defineEmits(["click-attendance"]);

function onClick() {
  emits("click-attendance", props.isAttendance);
}
</script>

<template>
  <div class="d-inline-block">
    <div
      class="attendance-button"
      data-testid="attendance-button"
      :class="[
        { 'attendance-button--on': isAttendance },
        { 'attendance-button--disabled': isDisabled }
      ]"
      @click="onClick"
    >
      <FeatherIcon icon="maximize" />{{ isAttendance ? "退勤" : "出勤" }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.attendance-button {
  padding: 8px;
  font-size: 14px;
  color: $mild;
  border: 1px solid $gray-03;
  border-radius: 8px;

  &--on {
    color: $white;
    background-color: $green;
    border-color: $green;
  }

  &--disabled {
    color: $gray-05;
    pointer-events: none;
    background-color: $gray-03;
    border-color: $gray-03;
  }

  svg {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
}
</style>
